import {
  Button,
  FormControl,
  MenuItem,
  Select,
  TextField as MUITextField,
  Typography,
} from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import InputLabel from "@material-ui/core/InputLabel";
import TableRow from "@material-ui/core/TableRow";
import { DatePicker } from "@material-ui/pickers";
import { useAddress } from "components/request-document/components/Address";
import {
  StyleCheckbox,
  StyledTableCell,
  useStyles,
} from "components/request-document/components/Commons";
import usePrevious from "libs/hooks/usePrevious";
import { getErrorMessage, isError } from "libs/utils/form";
import { get } from "lodash";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { canEditForm } from "redux/modules/authSlice";
import { selectMasterData } from "redux/modules/masterSlice";

const TextField = React.memo(MUITextField);

export default function DataPrivate({ formik }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const canEdit = useSelector(canEditForm);
  const addressFieldOptions = useAddress({ formik });
  const masterData = useSelector(selectMasterData);

  const isYearMonth = formik.values?.document.ContractTermTypeWorkTH === "Y";
  const isPeriod = formik.values?.document.ContractTermTypeWorkTH === "P";
  const isOther = formik.values?.document.ContractTermTypeWorkTH === "O";
  const jobPositionConfig = get(masterData, "jobPositionConfig", []);
  const jobTable = get(formik.values, `document.JobPositionWorkTH.0`, {});
  const jobSubPositionConfig =
    jobPositionConfig.find((job) => job.jobID === jobTable.jobID)
      ?.jobSubPosition || [];

  const index = 0;
  const prevJobPosition = usePrevious(formik.values.JobPosition);
  const isJobPositionChange =
    prevJobPosition && prevJobPosition !== formik.values.JobPosition;
  useEffect(() => {
    if (isJobPositionChange) {
      formik.setFieldValue("JobSubPosition", "");
    }
  }, [formik, isJobPositionChange]);
  const typeOforganizationConfig = get(
    masterData,
    "typeOforganizationConfig",
    []
  );
  const typeOfindustriesConfig = get(masterData, "typeOfindustriesConfig", []);
  // console.log(typeOfindustriesConfig);
  return (
    <>
      <TableRow>
        <StyledTableCell colSpan={7}>
          <div className={classes.cellContent}>
            <div
              className={classes.flexRow}
              style={{ flex: 1, display: "flex" }}
            >
              <InputLabel>Job position</InputLabel>
              <FormControl
                variant="outlined"
                className={classes.formControl}
                style={{ marginLeft: 16, flex: 1 }}
              >
                <InputLabel>Select Job position</InputLabel>
                <Select
                  disabled={!canEdit}
                  label="Select Job position"
                  name={`document.JobPositionWorkTH.${index}.jobID`}
                  defaultValue=""
                  // value={get(
                  //   formik.values,
                  //   `document.JobTable.${index}.jobID`,
                  //   ""
                  // )}
                  value={formik.values.document.JobPositionWorkTH[0].jobID}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  {jobPositionConfig.map((jobPosition) => (
                    <MenuItem key={jobPosition.jobID} value={jobPosition.jobID}>
                      {jobPosition.jobName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl
                variant="outlined"
                className={classes.formControl}
                style={{ marginLeft: 16, flex: 1 }}
              >
                <InputLabel>Select Job Sub position</InputLabel>

                <Select
                  disabled={!canEdit}
                  label="Select Job Sub position"
                  name={`document.JobPositionWorkTH.${index}.jobsubID`}
                  value={formik.values.document.JobPositionWorkTH[0].jobsubID}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  {jobSubPositionConfig.map((jobPosition) => (
                    <MenuItem
                      key={jobPosition.jobsubID}
                      value={jobPosition.jobsubID}
                    >
                      {jobPosition.jobsubName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          </div>
        </StyledTableCell>
      </TableRow>

      <TableRow>
        <StyledTableCell colSpan={7}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel style={{ width: 90 }}>Job Title</InputLabel>
              <TextField
                disabled={!canEdit}
                variant="outlined"
                className={classes.textField}
                name={`document.JobPositionWorkTH.${index}.jobTitle`}
                value={get(
                  formik.values,
                  `document.JobPositionWorkTH.${index}.jobTitle`,
                  ""
                )}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError(
                  `document.JobPositionWorkTH.${index}.jobTitle`,
                  formik
                )}
                helperText={getErrorMessage(
                  `document.JobPositionWorkTH.${index}.jobTitle`,
                  formik
                )}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>

      <TableRow>
        <StyledTableCell colSpan={7}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Job description</InputLabel>
              <TextField
                disabled={!canEdit}
                variant="outlined"
                className={classes.textField}
                name={`document.JobPositionWorkTH.${index}.jobDesc`}
                value={get(
                  formik.values,
                  `document.JobPositionWorkTH.${index}.jobDesc`,
                  ""
                )}
                error={isError(
                  `document.JobPositionWorkTH.${index}.jobDesc`,
                  formik
                )}
                helperText={getErrorMessage(
                  `document.JobPositionWorkTH.${index}.jobDesc`,
                  formik
                )}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                multiline
                rows={5}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCell colSpan={6}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel> Contract term</InputLabel>
              <FormGroup row>
                <FormControlLabel
                  control={
                    <StyleCheckbox
                      disabled={!canEdit}
                      name="Year"
                      checked={isYearMonth}
                      onChange={() =>
                        formik.setFieldValue(
                          "document.ContractTermTypeWorkTH",
                          "Y"
                        )
                      }
                    />
                  }
                  label="Year - Months"
                />
                <FormControlLabel
                  control={
                    <StyleCheckbox
                      disabled={!canEdit}
                      name="Period (dd-mm-yyyy to dd-mm-yyyy)"
                      checked={isPeriod}
                      onChange={() =>
                        formik.setFieldValue(
                          "document.ContractTermTypeWorkTH",
                          "P"
                        )
                      }
                    />
                  }
                  label="Period"
                />
                <FormControlLabel
                  control={
                    <StyleCheckbox
                      disabled={!canEdit}
                      name="Other"
                      checked={isOther}
                      onChange={() =>
                        formik.setFieldValue(
                          "document.ContractTermTypeWorkTH",
                          "O"
                        )
                      }
                    />
                  }
                  label="Other ( Please specify )"
                />
              </FormGroup>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flex: 1,
                }}
              >
                {isYearMonth && (
                  <>
                    <TextField
                      disabled={!canEdit}
                      className={classes.formControl}
                      variant="outlined"
                      placeholder="Year"
                      // type="number"
                      onKeyDown={(e) => {
                        const pattern = /[^0-9]/g;
                        const isNotAllow =
                          e.key.length === 1 && pattern.test(e.key);

                        if (isNotAllow) {
                          e.preventDefault();
                        }
                      }}
                      name="document.ContractYearWorkTH"
                      value={formik.values?.document.ContractYearWorkTH}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={isError("document.ContractYearWorkTH", formik)}
                      helperText={getErrorMessage(
                        "document.ContractYearWorkTH",
                        formik
                      )}
                    />
                    <TextField
                      disabled={!canEdit}
                      className={classes.formControl}
                      variant="outlined"
                      placeholder="Month"
                      // type="number"
                      onKeyDown={(e) => {
                        const pattern = /[^0-9]/g;
                        const isNotAllow =
                          e.key.length === 1 && pattern.test(e.key);

                        if (isNotAllow) {
                          e.preventDefault();
                        }
                      }}
                      name="document.ContractMonthsWorkTH"
                      value={formik.values?.document.ContractMonthsWorkTH}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={isError("document.ContractMonthsWorkTH", formik)}
                      helperText={getErrorMessage(
                        "document.ContractMonthsWorkTH",
                        formik
                      )}
                    />
                  </>
                )}
                {isPeriod && (
                  <>
                    <DatePicker
                      disabled={!canEdit}
                      className={classes.formControl}
                      inputVariant="outlined"
                      disableFuture={false}
                      openTo="year"
                      format="DD-MM-YYYY"
                      label="Start date"
                      views={["year", "month", "date"]}
                      name="document.ContractPeriodFromWorkTH"
                      maxDate={
                        formik.values?.document.ContractPeriodFromWorkTH
                          ? formik.values?.document.ContractPeriodFromWorkTH
                          : undefined
                      }
                      value={
                        formik.values?.document.ContractPeriodFromWorkTH || null
                      }
                      onChange={(date) => {
                        formik.setFieldValue(
                          "document.ContractPeriodFromWorkTH",
                          date.format("YYYY-MM-DD")
                        );
                      }}
                      error={isError(
                        "document.ContractPeriodFromWorkTH",
                        formik
                      )}
                      helperText={getErrorMessage(
                        "document.ContractPeriodFromWorkTH",
                        formik
                      )}
                    />
                    <DatePicker
                      disabled={!canEdit}
                      className={classes.formControl}
                      inputVariant="outlined"
                      // disableFuture={false}
                      openTo="year"
                      format="DD-MM-YYYY"
                      label="End date"
                      views={["year", "month", "date"]}
                      name="document.ContractPeriodToWorkTH"
                      minDate={
                        formik.values?.document.ContractPeriodToWorkTH
                          ? formik.values?.document.ContractPeriodToWorkTH
                          : undefined
                      }
                      value={
                        formik.values?.document.ContractPeriodToWorkTH || null
                      }
                      onChange={(date) => {
                        formik.setFieldValue(
                          "document.ContractPeriodToWorkTH",
                          date.format("YYYY-MM-DD")
                        );
                      }}
                      error={isError("document.ContractPeriodToWorkTH", formik)}
                      helperText={getErrorMessage(
                        "document.ContractPeriodToWorkTH",
                        formik
                      )}
                    />
                  </>
                )}
                {isOther && (
                  <TextField
                    disabled={!canEdit}
                    className={classes.formControl}
                    variant="outlined"
                    placeholder="Please specify"
                    name="document.ContractOtherWorkTH"
                    value={formik.values?.document.ContractOtherWorkTH}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={isError("document.ContractOtherWorkTH", formik)}
                    helperText={getErrorMessage(
                      "document.ContractOtherWorkTH",
                      formik
                    )}
                  />
                )}
              </div>
            </div>
          </div>
        </StyledTableCell>
      </TableRow>

      <TableRow>
        <StyledTableCell colSpan={4}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Average income per month* (Baht)</InputLabel>
              <TextField
                disabled={!canEdit}
                variant="outlined"
                className={classes.textField}
                name="document.CompanyAverIncomemonth"
                value={formik.values.document.CompanyAverIncomemonth}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("document.CompanyAverIncomemonth", formik)}
                helperText={getErrorMessage(
                  "document.CompanyAverIncomemonth",
                  formik
                )}
              />
            </div>
          </div>
        </StyledTableCell>

        <StyledTableCell colSpan={3}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Salary (Baht per month)</InputLabel>
              <TextField
                disabled={!canEdit}
                variant="outlined"
                className={classes.textField}
                name="document.CompanysSalary"
                value={formik.values.document.CompanysSalary}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("document.CompanysSalary", formik)}
                helperText={getErrorMessage("document.CompanysSalary", formik)}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>

      <TableRow>
        <StyledTableCell colSpan={7}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <Typography style={{ color: "gray" }}>
                Other items of income (Please specify)
              </Typography>
            </div>
          </div>
          <TextField
            disabled={!canEdit}
            variant="outlined"
            className={classes.textField}
            name="document.CompanyIncomeOther"
            value={formik.values.document.CompanyIncomeOther}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={isError("document.CompanyIncomeOther", formik)}
            helperText={getErrorMessage("document.CompanyIncomeOther", formik)}
          />
        </StyledTableCell>
      </TableRow>

      <TableRow>
        <StyledTableCell colSpan={7}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <Typography style={{ color: "gray" }}>
                Organization Name
              </Typography>
            </div>
          </div>
          <TextField
            disabled={!canEdit}
            variant="outlined"
            className={classes.textField}
            name="document.OrganizationName"
            value={formik.values.document.OrganizationName}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={isError("document.OrganizationName", formik)}
            helperText={getErrorMessage("document.OrganizationName", formik)}
          />
        </StyledTableCell>
      </TableRow>

      <TableRow>
        <StyledTableCell colSpan={7}>
          <div style={{ width: "50%" }}>
            <div className={classes.wrapField}>
              <InputLabel style={{ fontWeight: "bold" }}>
                Type of Organization
              </InputLabel>
            </div>
          </div>
          <FormGroup row>
            {typeOforganizationConfig.map((x) => (
              <>
                <FormControlLabel
                  control={
                    <StyleCheckbox
                      disabled={!canEdit}
                      name="document.typeOforganizationID"
                      checked={
                        formik.values.document.typeOforganizationID ===
                        x.typeOforganizationID
                      }
                      onClick={() => {
                        formik.setFieldValue(
                          "document.typeOforganizationID",
                          x.typeOforganizationID
                        );
                      }}
                    />
                  }
                  label={x.typeOforganizationName}
                />
              </>
            ))}
          </FormGroup>
        </StyledTableCell>
      </TableRow>

      <TableRow>
        <StyledTableCell colSpan={4}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>A reference person’s name </InputLabel>
              <TextField
                disabled={!canEdit}
                variant="outlined"
                className={classes.textField}
                name="document.OrganizationReferenceName"
                value={formik.values.document.OrganizationReferenceName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("document.OrganizationReferenceName", formik)}
                helperText={getErrorMessage(
                  "document.OrganizationReferenceName",
                  formik
                )}
              />
            </div>
          </div>
        </StyledTableCell>

        <StyledTableCell colSpan={3}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>A reference person’s position</InputLabel>
              <TextField
                disabled={!canEdit}
                variant="outlined"
                className={classes.textField}
                name="document.OrganizationReferencePosition"
                value={formik.values.document.OrganizationReferencePosition}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError(
                  "document.OrganizationReferencePosition",
                  formik
                )}
                helperText={getErrorMessage(
                  "document.OrganizationReferencePosition",
                  formik
                )}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCell colSpan={4}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>E-mail address</InputLabel>
              <TextField
                disabled={!canEdit}
                variant="outlined"
                className={classes.textField}
                name="document.OrganizationEmailAddress"
                value={formik.values.document.OrganizationEmailAddress}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("document.OrganizationEmailAddress", formik)}
                helperText={getErrorMessage(
                  "document.OrganizationEmailAddress",
                  formik
                )}
              />
            </div>
          </div>
        </StyledTableCell>

        <StyledTableCell colSpan={3}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Mobile phone number</InputLabel>
              <TextField
                disabled={!canEdit}
                variant="outlined"
                className={classes.textField}
                type="number"
                name="document.OrganizationMobileNumber"
                value={formik.values.document.OrganizationMobileNumber}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("document.OrganizationMobileNumber", formik)}
                helperText={getErrorMessage(
                  "document.OrganizationMobileNumber",
                  formik
                )}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCell colSpan={7}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <Typography style={{ color: "gray" }}>
                Details of activities that applicant will undertake in Thailand;
                Project description, your role in the project
              </Typography>
            </div>
          </div>
          <TextField
            disabled={!canEdit}
            variant="outlined"
            className={classes.textField}
            name="document.OrganizationDetailsActivities"
            value={formik.values.document.OrganizationDetailsActivities}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={isError("document.OrganizationDetailsActivities", formik)}
            helperText={getErrorMessage(
              "document.OrganizationDetailsActivities",
              formik
            )}
          />
        </StyledTableCell>
      </TableRow>

      <TableRow>
        <StyledTableCell colSpan={7}>
          <div className={classes.wrapField}>
            <InputLabel style={{ fontWeight: "bold" }}>
              Type of targeted industries most relevant to your employer or
              sponsor’s activities
            </InputLabel>
            <Select
              disabled={!canEdit}
              label="Selected Type of targeted industries most relevant to your employer or sponsor’s activities "
              name={`document.typeOfindustriesID`}
              value={formik.values.document.typeOfindustriesID}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              variant="outlined"
            >
              {typeOfindustriesConfig.map((x) => (
                <MenuItem
                  key={x.typeOfindustriesID}
                  value={x.typeOfindustriesID}
                >
                  {x.typeOfindustriesName}
                </MenuItem>
              ))}
            </Select>
          </div>
        </StyledTableCell>
      </TableRow>
    </>
  );
}
